export default __webpack_public_path__ + "static/media/img-small-mobile.32b5cee0.png";